export default "__VITE_ASSET__Cf$rhex8__"